<div class="row m-0">
  <div class="col-12 page-heading-wrapper">
    <gb-ui-page-heading [titleText]="this.selectedDepartment?.extra?.booking_details_page_title"
      [displayBacklink]="true" [backLinkText]="'COMMON.BACK' | translate" (back)="routerGoBack()"></gb-ui-page-heading>
  </div>
</div>
<div class="govuk-width-container">
  <div class="row">
    <div class="col-sm-12">
      <ui-stepper [steps]="steps"></ui-stepper>
    </div>
  </div>
  <div class="govuk-grid-row">
    <div class="govuk-grid-column-full">
      <h1>{{datastoreService.pageContent.booking_details_page_subtitle}}</h1>
      <p [innerHTML]="datastoreService.pageContent.booking_details_page_subtitle_body"></p>

      @if (agentMode) {
      <button type="button" class="govuk-button govuk-button--inverse heading-button" data-module="govuk-button"
        (click)="datastoreService?.agentRestart()">
        Agent Restart
      </button>
      }

      <hr />

      <div class="govuk-grid-row" id="main-content" tabindex="-1">
        <div class="govuk-grid-column-two-thirds">
          <form [formGroup]="customerDetailsForm">
            <h2 class="govuk-heading-l govuk-heading-l--inverse">
              {{ 'FORM.YOUR_TITLE' | translate }}
            </h2>

            <div class="govuk-form-group" [ngClass]="{
            'govuk-form-group--error':
              form.first_name.errors?.required === true && submitted
          }">

              <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="first_name">
                {{ 'COMMON.FIRST_NAME' | translate }}
              </label>

              <p *ngIf="submitted && form.first_name?.errors" id="first-name-error" class="govuk-error-message">
                <span class="govuk-visually-hidden">Error:</span>

                <!-- Required error -->
                <span *ngIf="form.first_name?.errors?.['required']">
                  {{
                  'COMMON.IS_REQUIRED'
                  | translate : { value: 'COMMON.FIRST_NAME' | translate }
                  }}
                </span>

                <!-- Max length error -->
                <span *ngIf="form.first_name?.errors?.['maxlength']">
                  {{
                  'COMMON.MAX_LENGTH'
                  | translate : {
                  value: 'COMMON.FIRST_NAME' | translate,
                  max: form.first_name.errors?.['maxlength']?.requiredLength
                  }
                  }}
                </span>
              </p>

              <input maxlength="49" aria-required="true" formControlName="first_name"
                class="govuk-input govuk-input--inverse" id="first_name" name="eventName" type="text"
                (change)="radioCopyChange()" [ngClass]="{
              'govuk-input--error':
                form.first_name.errors?.required === true && submitted
            }" />
            </div>

            <!-- <h2 class="mt-1 pb-4">{{'FORM.YOUR_TITLE' | translate}}</h2>
              <div class="govuk-form-group">
                  <label tabindex="0" for="fn"> <span aria-hidden="true" class="form-field-required-marker">
                          *</span> {{'COMMON.FIRST_NAME' | translate}}</label>
                  <input id="fn" type="text" class="form-control" formControlName="first_name" role="textbox">
                  <div *ngIf="submitted && form.first_name.errors" class="invalid-feedback">
                      <div *ngIf="form.first_name.errors?.required" role="alert" tabindex="0">
                          {{ 'COMMON.IS_REQUIRED' | translate: {value: 'COMMON.FIRST_NAME' | translate } }}
                      </div>
                  </div>
              </div> -->

            <div class="govuk-form-group" [ngClass]="{
            'govuk-form-group--error':
              form.last_name.errors?.required === true && submitted
          }">

              <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="last_name">
                {{ 'COMMON.LAST_NAME' | translate }}
              </label>

              <p *ngIf="submitted && form.last_name?.errors" id="last-name-error" class="govuk-error-message">
                <span class="govuk-visually-hidden">Error:</span>

                <!-- Required error -->
                <span *ngIf="form.last_name?.errors?.['required']">
                  {{
                  'COMMON.IS_REQUIRED'
                  | translate : { value: 'COMMON.LAST_NAME' | translate }
                  }}
                </span>

                <!-- Max length error -->
                <span *ngIf="form.last_name?.errors?.['maxlength']">
                  {{
                  'COMMON.MAX_LENGTH'
                  | translate : {
                  value: 'COMMON.LAST_NAME' | translate,
                  max: form.last_name.errors?.['maxlength']?.requiredLength
                  }
                  }}
                </span>
              </p>

              <input maxlength="49" aria-required="true" formControlName="last_name"
                class="govuk-input govuk-input--inverse" id="last_name" name="eventName" type="text"
                (change)="radioCopyChange()" [ngClass]="{
              'govuk-input--error':
                form.last_name.errors?.required === true && submitted
            }" />
            </div>

            <div class="govuk-form-group" [ngClass]="{
            'govuk-form-group--error':
              (form.email_address.errors?.required ||
                form.email_address.errors?.pattern) &&
              submitted
          }">

              <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="email_address">
                {{ 'COMMON.EMAIL_ADDRESS' | translate }}
              </label>

              <p *ngIf="submitted && form.email_address?.errors" id="event-name-error" class="govuk-error-message">
                <!-- required -->
                <ng-container *ngIf="form.email_address?.errors?.required">
                  <span class="govuk-visually-hidden">Error:</span>
                  {{
                  'COMMON.IS_REQUIRED'
                  | translate : { value: 'COMMON.EMAIL_ADDRESS' | translate }
                  }}
                </ng-container>
                <!-- pattern -->
                <ng-container *ngIf="form.email_address?.errors?.pattern">
                  <span class="govuk-visually-hidden">Error:</span>
                  {{
                  'COMMON.INVALID'
                  | translate : { value: 'COMMON.EMAIL_ADDRESS' | translate }
                  }}
                </ng-container>
              </p>

              <input aria-required="true" formControlName="email_address" class="govuk-input govuk-input--inverse"
                id="email_address" name="eventName" (change)="radioCopyChange()" type="text" [ngClass]="{
              'govuk-input--error':
                form.email_address.errors?.required === true && submitted
            }" />

              <ng-container *ngIf="adminJourney">
                <br />
                <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                  <div class="govuk-checkboxes__item">
                    <input aria-required="true" formControlName="email_address_consent" class="govuk-checkboxes__input"
                      id="email_address_consent_box" name="email_address_consent_box" type="checkbox" />

                    <label class="govuk-label govuk-checkboxes__label govuk-checkboxes__label--inverse"
                      for="email_address_consent_box">
                      {{ 'COMMON.ADMIN_EMAIL_HINT' | translate }}
                    </label>
                  </div>
                </div>
                <p class="govuk-error-message" *ngIf="submitted && form.email_address_consent.errors">
                  <span class="govuk-visually-hidden">Error:</span> As we are going
                  to be using email as the point of reminding customers about their
                  ceremony, we really need to ensure that this is correct at the
                  booking.
                </p>
              </ng-container>
            </div>

            <div *ngIf="adminJourney">
              <div class="govuk-notification-banner" role="region" aria-labelledby="govuk-notification-banner-title"
                data-module="govuk-notification-banner">
                <div class="govuk-notification-banner__header">
                  <h2 class="govuk-notification-banner__title" id="govuk-notification-banner-title">
                    ADMIN GUIDANCE: Email address required
                  </h2>
                </div>
                <div class="govuk-notification-banner__content">
                  <p aria-label="Notification message"
                    class="govuk-notification-banner__heading govuk-notification-banner__heading--inverse"
                    style="font-weight: 500 !important; font-size: 19px !important">
                    {{ 'COMMON.ADMIN_EMAIL_NOTIFICATION' | translate }} <br /><br />
                    {{ 'COMMON.ADMIN_EMAIL_NOTIFICATION_TWO' | translate }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Passwords -->
            <!-- <ng-container *ngIf="!adminJourney">
                  <div class="govuk-form-group govuk-password-input" data-module="govuk-password-input" #password>
                      <h3 class="govuk-label-wrapper">
                          <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="email_address">
                              <span aria-hidden="true" class="form-field-required-marker">
                                  *</span> {{'COMMON.PASSWORD' | translate}}
                          </label>
                      </h3>
                      <div id="password-name-hint" class="govuk-hint govuk-hint--inverse">
                          {{'COMMON.PASSWORD_HINT' | translate}}
                      </div>
                      <div id="password-name-hint" class="govuk-hint govuk-hint--inverse">
                          {{'COMMON.PASSWORD_HINT_TWO' | translate}}
                      </div>
                      <p *ngIf="submitted && form.password?.errors" id="event-name-error" class="govuk-error-message">
                          <span *ngIf="form.password?.errors?.passwordInvalid" class="govuk-visually-hidden">Error:</span>
                          {{
                          'COMMON.PASSWORD_PATTERN' | translate}}
                      </p>
                      <div class="govuk-input govuk-input--inverse __wrapper govuk-password-input__wrapper">
                          <input class="govuk-input govuk-input--inverse  govuk-password-input__input govuk-js-password-input-input"
                              id="password-input" formControlName="password" name="password" type="password"
                              spellcheck="false" autocomplete="current-password" autocapitalize="none">
                          <button type="button"
                              class="govuk-button govuk-button--secondary govuk-password-input__toggle govuk-js-password-input-toggle"
                              data-module="govuk-button" aria-controls="password-input" aria-label="Show password" hidden>
                              Show
                          </button>
                      </div>
                  </div>
              </ng-container> -->

            <!-- Passwords end-->

            <div class="govuk-form-group" [ngClass]="{
            'govuk-form-group--error':
              (form.contact_number.errors?.required ||
                form.contact_number.errors?.pattern ||
                form.contact_number.errors?.minlength ||
                form.contact_number.errors?.maxlength) &&
              submitted
          }">

              <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="contact_number">
                {{ 'COMMON.CONTACT_NUMBER' | translate }}
              </label>

              <div id="event-name-hint" class="govuk-hint govuk-hint--inverse">
                {{ 'COMMON.PHONE_HINT' | translate }}
              </div>
              <div id="event-name-hint" class="govuk-hint govuk-hint--inverse">
                {{ 'COMMON.PHONE_HINT_TWO' | translate }}
              </div>
              <p *ngIf="submitted && form.contact_number?.errors" id="event-name-error" class="govuk-error-message">
                <!-- required -->
                <ng-container *ngIf="form.contact_number?.errors?.required">
                  <span class="govuk-visually-hidden">Error:</span>
                  {{
                  'COMMON.IS_REQUIRED'
                  | translate : { value: 'COMMON.CONTACT_NUMBER' | translate }
                  }}
                </ng-container>
                <!-- pattern -->
                <ng-container *ngIf="form.contact_number?.errors?.pattern">
                  <span class="govuk-visually-hidden">Error:</span>
                  {{
                  'COMMON.INVALID'
                  | translate : { value: 'COMMON.CONTACT_NUMBER' | translate }
                  }}
                </ng-container>
                <!-- minlength -->
                <ng-container *ngIf="form.contact_number?.errors?.minlength">
                  <span class="govuk-visually-hidden">Error:</span>
                  {{
                  'COMMON.INVALID'
                  | translate : { value: 'COMMON.CONTACT_NUMBER' | translate }
                  }}
                </ng-container>
                <!-- maxlength -->
                <ng-container *ngIf="form.contact_number?.errors?.maxlength">
                  <span class="govuk-visually-hidden">Error:</span>
                  {{
                  'COMMON.INVALID'
                  | translate : { value: 'COMMON.CONTACT_NUMBER' | translate }
                  }}
                </ng-container>
              </p>
              <input aria-required="true" formControlName="contact_number" class="govuk-input govuk-input--inverse"
                id="contact_number" name="eventName" (change)="radioCopyChange()"
                (keypress)="keyPressNumberField($event)" type="text" maxlength="15" [ngClass]="{
              'govuk-input--error':
                form.contact_number.errors?.required === true && submitted
            }" />

              <ng-container *ngIf="adminJourney">
                <br />
                <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                  <div class="govuk-checkboxes__item">
                    <input aria-required="true" formControlName="contact_number_consent" class="govuk-checkboxes__input"
                      id="contact_number_consent_box" name="contact_number_consent_box" type="checkbox" />

                    <label class="govuk-label govuk-checkboxes__label govuk-checkboxes__label--inverse"
                      for="contact_number_consent_box">
                      {{ 'COMMON.ADMIN_CONTACT_NUMBER_HINT' | translate }}
                    </label>
                  </div>
                </div>
                <p class="govuk-error-message" *ngIf="submitted && form.contact_number_consent.errors">
                  <span class="govuk-visually-hidden">Error:</span> As we are going
                  to be using the contact number as the point of reminding customers
                  about their ceremony, we really need to ensure that this is
                  correct at the booking.
                </p>
              </ng-container>
            </div>

            <!-- <div class="govuk-radios" data-module="govuk-radios">
                  <h3 class="govuk-label-wrapper">
                      <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="contact_number">
                          {{'COMMON.COPY_DETAILS' | translate}}
                      </label>
                  </h3>
                  <div class="govuk-radios" data-module="govuk-radios">
                      <div class="govuk-radios__item">
                          <input formControlName="copyData" (change)="updateRadio(customerDetailsForm,'copyData','Yes')"
                              class="govuk-radios__input" id="Yes" name="copyData" type="radio" value="Yes">
                          <label class="govuk-label govuk-radios__label govuk-radios__label--inverse" for="Yes">
                              Yes
                          </label>
                      </div>
                      <div class="govuk-radios__item">
                          <input formControlName="copyData" (change)="updateRadio(customerDetailsForm,'copyData','No')"
                              class="govuk-radios__input" id="No" name="copyData" type="radio" value="No">
                          <label class="govuk-label govuk-radios__label govuk-radios__label--inverse" for="No">
                              No
                          </label>
                      </div>
                  </div>
              </div> -->

            <!-- Customer questions -->
            <div *ngFor="let question of customerQuestions">
              <!-- questions that arent required -->
              <ng-container *ngIf="!question.required">
                <div class="govuk-form-group" *ngIf="question.visible && question.detail_type === 'text_field'">

                  <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="{{ question.reference }}">
                    {{ question.name | translate }}
                  </label>

                  <input [attr.aria-required]="question.required ? 'true' : null"
                    formControlName="{{ question.reference }}" class="govuk-input govuk-input--inverse"
                    id="{{ question.reference }}" name="{{ question.reference }}" type="text" />
                </div>

                <div class="govuk-form-group" *ngIf="question.visible && question.detail_type === 'text_area'">

                  <label class="govuk-label govuk-label--l" for="more-detail">
                    Can you provide more detail?
                  </label>

                  <div id="more-detail-hint" class="govuk-hint govuk-hint--inverse">
                    Do not include personal or financial information, like your
                    National Insurance number or credit card details
                  </div>
                  <textarea class="govuk-textarea--inverse" id="more-detail" name="moreDetail" rows="5"
                    aria-describedby="more-detail-hint"></textarea>
                </div>


                <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="{{ question.reference }}">
                  {{ question.name | translate }}
                </label>


                <input [attr.aria-required]="question.required ? 'true' : null"
                  formControlName="{{ question.reference }}" class="govuk-input govuk-input--inverse"
                  id="{{ question.reference }}" name="{{ question.reference }}" type="text" />

                <div class="govuk-form-group" *ngIf="question.visible && question.detail_type === 'number'">
                  <label tabindex="0" [for]="question.reference">
                    {{ question.name | translateSplit }}</label>
                  <input [attr.aria-required]="question.required ? 'true' : null" [id]="question.reference"
                    type="search" class="form-control" formControlName="{{ question.reference }}"
                    attr.aria-label="{{ question.name }} input field" (keypress)="keyPressNumberField($event)"
                    maxlength="11" />
                  <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                    <div *ngIf="form[question.reference].errors.required" role="alert">
                      {{
                      'COMMON.IS_REQUIRED'
                      | translate : { value: question.name | translateSplit }
                      }}
                    </div>
                  </div>
                </div>

                <div class="govuk-form-group" *ngIf="
                (question.visible && question.detail_type === 'select') ||
                (question.visible && question.detail_type === 'select-price')
              ">
                  <label tabindex="0" [for]="question.reference">
                    {{ question.name | translateSplit }}</label>

                  <ng-select [attr.aria-required]="question.required ? 'true' : null" [searchable]="false"
                    [clearable]="false" appearance="outline" id="{{ question.reference }}"
                    formControlName="{{ question.reference }}" bindLabel="name" bindValue="name"
                    [items]="question.options" (change)="onQuestionChange()">
                  </ng-select>

                  <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                    <div *ngIf="form[question.reference].errors.required" role="alert">
                      {{
                      'COMMON.IS_REQUIRED'
                      | translate : { value: question.name | translateSplit }
                      }}
                    </div>
                  </div>
                </div>

                <div class="govuk-form-group" *ngIf="
                question.visible &&
                question.detail_type === 'date' &&
                question.id !== 1
              ">
                  <label tabindex="0" [for]="question.reference">
                    {{ question.name | translateSplit }}</label>
                  <input [id]="question.reference" matInput formControlName="{{ question.reference }}"
                    [matDatepicker]="picker" readonly />
                  <mat-datepicker-toggle matSuffix [for]="picker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker> </mat-datepicker>
                  <span *ngIf="question.help_text" class="help-text" tabindex="0"
                    [innerHTML]="question.help_text | translateSplit | noSanitise">
                  </span>
                  <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                    <div *ngIf="form[question.reference].errors.required" role="alert">
                      {{
                      'COMMON.IS_REQUIRED'
                      | translate : { value: question.name | translateSplit }
                      }}
                    </div>
                    <div *ngIf="form[question.reference].errors.pattern" role="alert">
                      {{ 'COMMON.AGE_VALIDATION' | translate }}
                    </div>
                  </div>
                </div>

                <!-- checkbox -->
                <div class="govuk-form-group" *ngIf="
                (question.visible && question.detail_type === 'check') ||
                (question.visible && question.detail_type === 'check-price')
              ">
                  <mat-checkbox formControlName="{{ question.reference }}" class="" [id]="question.reference">
                    <label tabindex="0" [for]="question.reference"></label>
                    <span *ngIf="question.price == 0">{{ question.name }}</span>

                    <span tabindex="-1" *ngIf="question.price > 0">{{ question.name }} -
                      {{ question.price / 100 | currency : 'GBP' : true }}</span>
                  </mat-checkbox>

                  <span *ngIf="question.help_text" class="help-text" tabindex="0"
                    innerHTML="question.help_text | translateSplit | noSanitise">
                  </span>

                  <div *ngIf="submitted && form[question.reference].errors?.required" role="alert" tabindex="0"
                    class="invalid-feedback">
                    {{
                    'COMMON.IS_REQUIRED'
                    | translate : { value: question.name | translateSplit }
                    }}
                  </div>
                  <div *ngIf="submitted && form[question.reference].errors?.pattern" role="alert">
                    {{ question?.validation_message }}
                  </div>
                </div>
              </ng-container>

              <!-- questions that are required -->
              <ng-container *ngIf="question.required">
                <div class="govuk-form-group" [ngClass]="{
                'govuk-form-group--error':
                  form[question.reference].errors?.required === true &&
                  submitted
              }" *ngIf="question.visible && question.detail_type === 'text_field'">

                  <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="{{ question.reference }}">
                    {{ question.name | translate }}
                  </label>

                  <p *ngIf="submitted && form[question.reference].errors?.errors" id="event-name-error"
                    class="govuk-error-message">
                    <span class="govuk-visually-hidden">Error:</span>
                    {{
                    'COMMON.IS_REQUIRED'
                    | translate : { value: question.name | translate }
                    }}
                  </p>
                  <input [attr.aria-required]="question.required ? 'true' : null"
                    formControlName="{{ question.reference }}" class="govuk-input govuk-input--inverse"
                    id="{{ question.reference }}" name="{{ question.reference }}" type="text" [ngClass]="{
                  'govuk-input--error':
                    form[question.reference].errors?.required === true &&
                    submitted
                }" />
                </div>

                <div class="govuk-form-group" *ngIf="question.visible && question.detail_type === 'text_area'">

                  <label class="govuk-label govuk-label--l" for="more-detail">
                    Can you provide more detail?
                  </label>

                  <div id="more-detail-hint" class="govuk-hint govuk-hint--inverse">
                    Do not include personal or financial information, like your
                    National Insurance number or credit card details
                  </div>
                  <textarea class="govuk-textarea--inverse" id="more-detail" name="moreDetail" rows="5"
                    aria-describedby="more-detail-hint"
                    [attr.aria-required]="question.required ? 'true' : null"></textarea>
                </div>


                <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="{{ question.reference }}">
                  {{ question.name | translate }}
                </label>


                <input formControlName="{{ question.reference }}" class="govuk-input govuk-input--inverse"
                  id="{{ question.reference }}" name="{{ question.reference }}" type="text" />

                <div class="govuk-form-group" *ngIf="question.visible && question.detail_type === 'number'">
                  <label tabindex="0" [for]="question.reference">
                    {{ question.name | translateSplit }}</label>
                  <input [attr.aria-required]="question.required ? 'true' : null" [id]="question.reference"
                    type="search" class="form-control" formControlName="{{ question.reference }}"
                    attr.aria-label="{{ question.name }} input field" (keypress)="keyPressNumberField($event)"
                    maxlength="11" />
                  <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                    <div *ngIf="form[question.reference].errors.required" role="alert">
                      {{
                      'COMMON.IS_REQUIRED'
                      | translate : { value: question.name | translateSplit }
                      }}
                    </div>
                  </div>
                </div>

                <div class="govuk-form-group" *ngIf="
                (question.visible && question.detail_type === 'select') ||
                (question.visible && question.detail_type === 'select-price')
              ">
                  <label tabindex="0" [for]="question.reference">
                    {{ question.name | translateSplit }}</label>

                  <ng-select [attr.aria-required]="question.required ? 'true' : null" [searchable]="false"
                    [clearable]="false" appearance="outline" id="{{ question.reference }}"
                    formControlName="{{ question.reference }}" bindLabel="name" bindValue="name"
                    [items]="question.options" (change)="onQuestionChange()">
                  </ng-select>

                  <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                    <div *ngIf="form[question.reference].errors.required" role="alert">
                      {{
                      'COMMON.IS_REQUIRED'
                      | translate : { value: question.name | translateSplit }
                      }}
                    </div>
                  </div>
                </div>

                <div class="govuk-form-group" *ngIf="
                question.visible &&
                question.detail_type === 'date' &&
                question.id !== 1
              ">
                  <label tabindex="0" [for]="question.reference">
                    {{ question.name | translateSplit }}</label>
                  <input [id]="question.reference" matInput formControlName="{{ question.reference }}"
                    [matDatepicker]="picker" readonly />
                  <mat-datepicker-toggle matSuffix [for]="picker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker> </mat-datepicker>
                  <span *ngIf="question.help_text" class="help-text" tabindex="0"
                    [innerHTML]="question.help_text | translateSplit | noSanitise">
                  </span>
                  <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                    <div *ngIf="form[question.reference].errors.required" role="alert">
                      {{
                      'COMMON.IS_REQUIRED'
                      | translate : { value: question.name | translateSplit }
                      }}
                    </div>
                    <div *ngIf="form[question.reference].errors.pattern" role="alert">
                      {{ 'COMMON.AGE_VALIDATION' | translate }}
                    </div>
                  </div>
                </div>

                <!-- checkbox -->
                <div class="govuk-form-group" *ngIf="
                (question.visible && question.detail_type === 'check') ||
                (question.visible && question.detail_type === 'check-price')
              ">
                  <mat-checkbox formControlName="{{ question.reference }}" class="" [id]="question.reference">
                    <label tabindex="0" [for]="question.reference"></label>
                    <span *ngIf="question.price == 0">{{ question.name }}</span>

                    <span tabindex="-1" *ngIf="question.price > 0">{{ question.name }} -
                      {{ question.price / 100 | currency : 'GBP' : true }}</span>
                  </mat-checkbox>

                  <span *ngIf="question.help_text" class="help-text" tabindex="0"
                    innerHTML="question.help_text | translateSplit | noSanitise">
                  </span>

                  <div *ngIf="submitted && form[question.reference].errors?.required" role="alert" tabindex="0"
                    class="invalid-feedback">
                    {{
                    'COMMON.IS_REQUIRED'
                    | translate : { value: question.name | translateSplit }
                    }}
                  </div>
                  <div *ngIf="submitted && form[question.reference].errors?.pattern" role="alert">
                    {{ question?.validation_message }}
                  </div>
                </div> 
              </ng-container>
            </div>
            <!-- <br /> -->
          </form>

          <ng-container *ngIf="showFormBuilder">
            <lib-form-builder [appConfig]="appConfig" [formId]="selectedFormId" [formData]="formData"
              [companyId]="37003" [showSubmit]="false" [inlineRequiredCheckboxWarning]="true"
              [requiredCheckboxWarningMessage]="requiredCheckboxWarningMessage"
              (formStatus)="updateAnswers($event)"
              (formReady)="formReady($event)" (extraItemSet)="onExtraItemSet($event)"
              (extraItemChanged)="onExtraItemChanged($event)" (formSubmit)="onSubmit()"
              (processing)="onFormProcessing($event)">
            </lib-form-builder>
          </ng-container>

        </div>

        <div class="govuk-grid-column-one-third no-mobile">
          <app-booking-summary></app-booking-summary>
        </div>

        <!-- <div class="govuk-grid-column-two-thirds">
          <div class="row pb-4">
            <div class="col-sm-12">
              <button type="submit" class="govuk-button govuk-button--inverse" data-module="govuk-button"
                (click)="onSubmit()">
                {{ 'COMMON.NEXT' | translate }}
              </button>
            </div>
          </div>
        </div> -->
      </div>
    </div>